import { render } from "./SelectBlockRating.vue?vue&type=template&id=cf0788fa&scoped=true"
import script from "./SelectBlockRating.vue?vue&type=script&lang=js"
export * from "./SelectBlockRating.vue?vue&type=script&lang=js"

import "./SelectBlockRating.vue?vue&type=style&index=0&id=cf0788fa&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf0788fa"]])

export default __exports__